<template>
  <div class="page">
    <div class="mains-content">
      <div class="p16">
        会员管理
      </div>
      <div class="member-content-box">
        <div class="member-header">
          <div class="align-items">
            <el-select v-model="query.notTradeType" placeholder="最近交易范围" @change="search" class="member-select">
              <el-option v-for="item in options" :key="item.catId" :label="item.name" :value="item.catId">
              </el-option>
            </el-select>
            <!-- <el-input
              placeholder="请输入会员手机号/身份证/姓名/备注"
              v-model="query.keyword"
              clearable
              class="member-input ml10 mr10"
              maxlength="24"
            ></el-input>
            <el-button type="primary" @click="search">搜索</el-button> -->
            <member @handleChange="memberChange" class="ml10"></member>
          </div>

          <el-button type="primary" @click="addClick()"
            v-perm="{ key: 'memberManager', value: 'memberManager:add' }">注册会员</el-button>
        </div>
        <div class="tables" v-perm="{ key: 'memberManager', value: 'memberManager:list' }">
          <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
            <el-table-column align="left" prop="nickName" label="会员姓名"></el-table-column>
            <el-table-column align="left" prop="mobile" label="联系方式" min-width="100px"></el-table-column>
            <el-table-column align="left" prop="walletAmount" label="会员卡余额" min-width="90px">
              <template slot-scope="scope">￥{{ scope.row.walletAmount.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column align="left" prop="customerNo" label="性别" min-width="60px">
              <template slot-scope="scope">{{ scope.row.gender == 'male' ? '男' : '女' }}</template>
            </el-table-column>
			<el-table-column align="left" prop="silenceDay" label="沉默天数"></el-table-column>
            <el-table-column align="left" prop="memberSourceCn" label="会员账号状态" width="110px">
              <template slot-scope="scope">{{ scope.row.accountStatus }}</template>
            </el-table-column>
            <el-table-column align="left" prop="memberRemark" label="会员备注" min-width="100px"></el-table-column>
            <el-table-column align="left" label="最后消费时间" width="160px">
              <template slot-scope="scope">{{ formatDate(scope.row.lastTradeTime) }}</template>
            </el-table-column>
            <el-table-column align="left" label="操作" width="240px" fixed="right">
              <template slot-scope="scope">
                <el-link type="primary" @click="detailPage(scope.row)">会员资料</el-link><el-divider
                  direction="vertical"></el-divider>
                <span v-if="userInfo.manageModel == 'alone' && !userInfo.superManage">
                  <!-- “申请挂失”菜单 单店模式非店长权限的人不可见 -->
                </span>
                <span v-perm="{ key: 'memberManager', value: 'memberManager:lossApply' }" v-else>
                  <el-link type="primary" @click="memberLossApply(scope.row)">申请挂失</el-link><el-divider
                    direction="vertical"></el-divider>
                </span>
                <el-link type="primary" v-perm="{ key: 'memberManager', value: 'memberManager:freeSecret' }"
                  @click="passwordBypass(scope.row)">小额免密</el-link>
              </template>
            </el-table-column>
          </el-table>
          <paging :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="editChange"></edit-set>
    <detail-set ref="detailSetForm"></detail-set>
    <card-set ref="cardSetForm"></card-set>
    <update-pwd ref="updatePwdSetForm"></update-pwd>
    <member-loss ref="memberLossForm"></member-loss>

    <password-bypass ref="passwordBypass" @change="updateInfo"></password-bypass>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import editSet from "./edit";
import cardSet from "./card";
import detailSet from "./detail";
import updatePwd from "./updatePwd";

import memberLoss from "./memberLoss";
import passwordBypass from "./passwordBypass";
import member from "../components/noBgMember.vue";

export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      options: [],
      url: this.$url.member.lists,
      query: {
        keyword: ""
      },
      centerDialogVisible: false,
      form: {},
      userInfo: {
        shopBizConfig: {
        }
      },
      codeName: true,
      time: 60,
      height: this.$store.getters.MainHeight,
    };
  },
  components: {
    editSet,
    cardSet,
    detailSet,
    updatePwd,
    member,
    passwordBypass,
    memberLoss
  },
  created() {
    this.userInfo = this.$store.getters.ShopInfo;
    this.totalCounts();
    this.listNotTradeRange();

  },
  mounted() {
    if (localStorage.getItem("tradeNoPwdFlag")) {
      // 免密支付
      let a = JSON.parse(localStorage.getItem("tradeNoPwdFlag"))
      this.$refs["passwordBypass"].$emit("set", a);
    }
  },
  methods: {
    listNotTradeRange() {
      this.$api.get(this.$url.member.listNotTradeRange).then(res => {
        if (res) {
          console.log(res)
          this.options = res
          this.options.unshift({ catId: "", name: '最近交易范围' })
        }
      })
    },
    memberLossApply(item) {
      // 申请挂失
      this.$refs["memberLossForm"].$emit("set", item);
    },
    passwordBypass(item) {
      // 免密支付
      this.$refs["passwordBypass"].$emit("set", item);
    },
    addClick(item) {
      item == undefined
        ? this.$refs["editSetForm"].$emit("set", null)
        : this.$refs["editSetForm"].$emit("set", item);
    },
    memberChange (value) {
      console.log(value,' vaaaa');
      if (value) {
        this.query.keyword = value;
      } else {
        this.query.keyword = "";
      }
      this.totalCounts();
    },
    search() {
      this.list = [];
      this.query.start = 1;
      this.totalCounts();
    },
    editChange(bool) {
      if (bool) {
        this.query = {
          mobile: "",
          start: 1,
          size: 20
        };
        this.totalCounts();
      }
    },

    detailPage(item) {
      this.$router.push(`/member/detail/${item.id}`);
      //   this.$refs["detailSetForm"].$emit("set", item);
    },
    updatePage(item) {
      this.$refs["updatePwdSetForm"].$emit("set", item);
    },
    updateMobile(item) {
      // 修改手机号
      this.$refs["updateMobile"].$emit("set", { id: item.id, mobile: item.mobile });
    },
    repairDocumentPage(item) {
      this.$router.push({
        path: "/paperRepair/edit",
        query: { mobile: item.mobile }
      });
    },
    updateInfo(org) {
      if (org) {
        this.getData()
      }
    },
    cardPage(item) {
      this.$refs["cardSetForm"].$emit("set", item);
    },
    totalCounts() {
      this.$api.post(this.$url.member.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    orderInfoPage(item) {
      this.$router.push({
        name: "/orderInfo",
        params: {
          item: {
            orderStatus: "waitExtract",
            customerName: item.mobile
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/edit.less";

/deep/ .el-input-group__append {
  background-color: #409eff;
  border: 1px solid #409eff;
  color: #fff;
}

.mains-content {
  min-height: 500px;
  height: 100%;

  .member-content-box {
    padding: 0 16px 16px;

  }

  .tables {
    background: #fff;
    border-radius: 10px;
  }

  .member-header {
    background: #fff;
    padding: 0 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px 10px 0 0;
    .isMember {
      width: 450px !important;
    }
    .input-with-select {
      width: 304px;
      height: 40px;
      margin-right: 15px;

      /deep/ .el-input__inner {
        height: 40px;
        line-height: 40px;
        padding-left: 35px;
      }

      /deep/ .el-input__clear {
        font-size: 22px;
        line-height: 40px;
      }

      /deep/ .el-input__prefix {
        color: @blue;
        font-size: 24px;
        margin-right: 10px;

        .el-input__icon {
          line-height: 40px;
        }
      }
    }
  }
}
</style>